import { useSelector } from 'react-redux';
import EnterpriseLBADeveloper from '@/components/Rover/DeveloperApplications/EnterpriseLBADevelopers/EnterpriseLBADeveloper';
import Unauthorized from '@/components/Unauthorized';
import { ClientAccount } from '../../../../constants/DeveloperApplication';
import { authSelector } from '../../../../store';
import { getEnvironment } from '../../../../utils';

const PartnerProposal = () => {
  const { data: currentUserData } = useSelector(authSelector);
  const { account } = currentUserData;
  const currentEnv = getEnvironment();

  switch (account.toUpperCase()) {
    case ClientAccount.LETS_BUILD_ACCELERATOR:
      return <EnterpriseLBADeveloper />;
    default:
      if (currentEnv === 'DEV') {
        return <EnterpriseLBADeveloper />;
      }
      return <Unauthorized />;
  }
};
export default PartnerProposal;
